import React, { FC } from 'react';
import {
  TextStyle,
  TouchableOpacity,
  View,
  ActivityIndicator,
} from 'react-native';
import { authStyles } from '../styles';
import { IAuthProps } from '../types';
import { Text } from '../../../components/Text/Text';
import { TextInput } from '../../../components/TextInput/TextInput';
import { getContentWidth, getHeight } from '../../../constants/platform';
import { STYLE_VARS } from '../../../constants/style-vars';
import { Button } from '../../../components/Button';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';

export const ForgotLogin: FC<IAuthProps> = ({
  state,
  setState,
  onLoginPress,
}) => {
  const isDesktop = useIsDesktop();

  return (
    <View style={authStyles.container}>
      <Text
        style={[
          authStyles.title,
          { textAlign: isDesktop() ? 'left' : 'center' },
        ]}
      >
        FORGOT USERNAME
      </Text>
      <TextInput
        style={[
          isDesktop() ? STYLE_VARS.textinputweb : STYLE_VARS.textinput,
          authStyles.inputWithNote,
        ]}
        value={state.mbnum}
        onChangeText={(text) => setState({ mbnum: text })}
        placeholder="MEMBERSHIP NUMBER"
        placeholderTextColor="grey"
      />
      <Text style={authStyles.note}>
        PLEASE ENTER FULL MEMBERSHIP NUMBER {'(1 LETTER AND 4 NUMBERS)'}
      </Text>
      <TextInput
        style={
          (isDesktop()
            ? STYLE_VARS.textinputweb
            : STYLE_VARS.textinput) as TextStyle
        }
        value={state.email}
        onChangeText={(text) => setState({ email: text })}
        placeholder="EMAIL"
        placeholderTextColor="grey"
      />
      <View
        style={[
          authStyles.submitwrap,
          { width: isDesktop() ? 300 : undefined },
        ]}
      >
        <Button
          text="SUBMIT"
          style={{
            paddingVertical: 12,
            paddingHorizontal: 24,
            alignSelf: isDesktop() ? 'flex-start' : 'center',
          }}
          onPress={onLoginPress}
          disabled={state.submitDisabled}
        />
      </View>

      <TouchableOpacity
        style={[
          authStyles.link,
          { alignItems: isDesktop() ? 'flex-start' : 'center' },
        ]}
        onPress={() => {
          setState({ mode: 'login' });
        }}
      >
        <Text>LOGIN</Text>
      </TouchableOpacity>

      <TouchableOpacity
        style={[
          authStyles.link,
          { alignItems: isDesktop() ? 'flex-start' : 'center' },
        ]}
        onPress={() => {
          setState({
            mode: 'create',
            mbnum: '',
            email: '',
            login: '',
            password: '',
            password2: '',
          });
        }}
      >
        <Text>SIGN UP</Text>
      </TouchableOpacity>

      {state.submitDisabled && (
        <View
          style={[
            authStyles.activityIndWrap,
            {
              width:
                isDesktop() && getContentWidth() >= 768
                  ? 340
                  : getContentWidth(),
              height:
                isDesktop() && getContentWidth() >= 768 ? 320 : getHeight(),
            },
          ]}
        >
          <ActivityIndicator size="large" />
        </View>
      )}
    </View>
  );
};
